import e from "../managers/braze-instance.js";
import g from "./content-cards-provider-factory.js";
export function subscribeToContentCardsUpdates(r) {
  if (!e.rr()) return;
  const t = g.er(),
    n = t.ri(r);
  if (!t.Wt()) {
    const r = e.cr();
    if (r) {
      const n = r.pr(() => {
        t.Ms();
      });
      n && t.Xt(n);
    }
  }
  return n;
}
